/* eslint-disable multiline-ternary */
import {
  createStyles,
  Grid,
  LinearProgress,
  makeStyles,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import clsx from 'clsx'
import { IolProperties } from '../../types/graphql'
import { useIolForm } from './useIolForm'

const BorderLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 8
    },
    colorPrimary: {
      backgroundColor: '#fff'
    },
    bar: {
      backgroundColor: '#1CCB00',
      borderRadius: 8
    }
  })
)(LinearProgress)

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'space-around',
      alignContent: 'center',
      width: '100%',
      height: '15vh',
      padding: '13px 30px 0px 30px',
      marginBottom: '15px'
    },
    container: {
      border: '2px solid #fff',
      background: 'rgba(222,222,222,0.2)',
      padding: 5
    },
    icon: {
      color: '#999'
    },
    iconChecked: {
      color: 'green',
      transition: theme.transitions.create('color', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    iconFalse: {
      color: 'red',
      transition: theme.transitions.create('color', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  })
)

type PropertiesProps = {
  properties: IolProperties
}

const Properties: React.FC<PropertiesProps> = ({ properties }) => {
  const classes = useStyles()
  const [progress, setProgress] = useState<number[]>([])
  const [satProgress, setSatProgress] = useState<number[]>([])
  const { isEditing, data } = useIolForm()

  const { graphics, satisfaction, items } = !isEditing
    ? properties
    : data.properties

  useEffect(() => {
    const newProgress = graphics.map(g => g?.value || 0)
    setProgress(newProgress)
    const newSat = satisfaction.map(s => s?.value || 0)
    setSatProgress(newSat)
  }, [graphics, satisfaction])

  return (
    <div className={classes.root}>
      <Grid container justify="space-between">
        <Grid item xs={7} spacing={2} container className={classes.container}>
          <Grid
            item
            xs={12}
            direction="row"
            alignItems="flex-start"
            style={{
              display: 'flex',
              flex: 1,
              flexWrap: 'wrap',
              padding: 0,
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '50%',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-around'
              }}
            >
              {items.map((item, index) => {
                if (index < 3) {
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center'
                      }}
                    >
                      {item?.hasProperty ? (
                        <CheckCircleIcon
                          className={clsx(classes.icon, {
                            [classes.iconChecked]: item?.hasProperty
                          })}
                        />
                      ) : (
                        <CancelIcon
                          className={clsx(classes.icon, {
                            [classes.iconFalse]: !item?.hasProperty
                          })}
                        />
                      )}
                      <Typography
                        variant="subtitle2"
                        style={{ color: 'white' }}
                      >
                        {item?.name}
                      </Typography>
                    </div>
                  )
                } else {
                  return <></>
                }
              })}
            </div>
            <div
              style={{
                width: '50%',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-around'
              }}
            >
              {items.map((item, index) => {
                if (index >= 3) {
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center'
                      }}
                    >
                      {item?.hasProperty ? (
                        <CheckCircleIcon
                          className={clsx(classes.icon, {
                            [classes.iconChecked]: item?.hasProperty
                          })}
                        />
                      ) : (
                        <CancelIcon
                          className={clsx(classes.icon, {
                            [classes.iconFalse]: !item?.hasProperty
                          })}
                        />
                      )}
                      <Typography
                        variant="subtitle2"
                        style={{ color: 'white' }}
                      >
                        {item?.name}
                      </Typography>
                    </div>
                  )
                } else {
                  return <></>
                }
              })}
            </div>
          </Grid>
        </Grid>
        <Grid item xs={5} spacing={2} container className={classes.container}>
          <Grid
            container
            direction="column"
            justify="space-around"
            alignItems="flex-start"
            xs={8}
            style={{ color: '#fff' }}
          >
            {graphics.map((graph, index) => (
              <Grid item style={{ width: '90%' }} key={graph?.name}>
                <Typography variant="subtitle2" color="inherit">
                  {graph?.name}
                </Typography>
                <div>
                  <BorderLinearProgress
                    variant="determinate"
                    value={progress[index] || 0}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
          <Grid
            container
            xs={4}
            justify="flex-start"
            alignItems="flex-start"
            style={{
              color: '#fff',
              position: 'relative'
            }}
          >
            <div
              style={{
                width: '80px',
                height: '80px',
                margin: 'auto',
                position: 'absolute',
                bottom: 0,
                left: 0,
                transform: 'rotate(-90deg)'
              }}
            >
              {satisfaction.map((sat, index) => (
                <React.Fragment key={sat?.name}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={satProgress[index] || 0}
                  />
                  <br />
                </React.Fragment>
              ))}
            </div>
            <Typography
              style={{
                position: 'absolute',
                top: -8,
                left: 0
              }}
              variant="subtitle2"
              color="inherit"
            >
              Satisfação
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default Properties
